import sumBy from 'lodash/sumBy'
import React, { useEffect } from 'react'
import { components as defaultComponents } from './components'
import { CoreProvider } from './Context'
import { Layout } from './Layout'
import { roundNumber } from '@ztechapps/common.utils'
import type { Payment } from '@ztechapps/common.contract'
import { useCheckoutContext } from '../../index'

export const PaymentMethodPanel = ({ components, ...props }) => {
  const checkoutContext = useCheckoutContext()

  components = { ...defaultComponents, ...components }
  const net = checkoutContext.orderNetAmount
  const { document } = checkoutContext.orderDocumentResult
  const orderNetAmount = net

  const payments: Payment[] = document?.payments
  const hasPartialPayments = checkoutContext.hasPartialPayments

  const [isPartial, setIsPartial] = React.useState<boolean>(false)
  useEffect(() => {
    setIsPartial(hasPartialPayments)
  }, [hasPartialPayments])

  // React.useEffect(() => {
  //   if (!isEmpty(document?.payments) && isEmpty(isPartial)) {
  //     setIsPartial(true)
  //   }
  // }, [payments])

  const [balance, setBalance] = React.useState<number>()
  const [totalPaid, setTotalPaid] = React.useState<number>()

  React.useEffect(() => {
    let computedBalance = orderNetAmount

    if (document?.payments) {
      let totalPaid: number = sumBy(payments, (item) => {
        return item?.gross
      })

      totalPaid = roundNumber(totalPaid, 2)
      setTotalPaid(totalPaid)
      let toPay = orderNetAmount - totalPaid
      toPay = roundNumber(toPay, 2)

      computedBalance = toPay
    }

    if (computedBalance < 0) {
      computedBalance = 0
    }
    setBalance(computedBalance)
  }, [orderNetAmount, document?.payments, payments])

  return (
    <CoreProvider value={{ components, isPartial, setIsPartial, totalPaid, balance, ...props }}>
      <Layout />
    </CoreProvider>
  )
}
